import { store } from "../store/store";
import {ERROR_MESSSAGE} from "../store/config";

/**
 * Function to show notification
 */
function showNotification(currMail) {
  store.dispatch("globalMessagePopup", {
    message: ERROR_MESSSAGE.newMail,
    action: `/emails/inbox/${currMail.mailBoxId}`,
    time: 20
  });
}

/**
 * Add mail to the list of mails
 * @param newMail
 */
function addMail(newMail) {
  // Get email list
  let emails = store.getters["portalemail/getEmails"];
  if(emails) {

    store.commit("portalemail/increaseUnreadMailCountOnOtherPage");

    if(
      (0 === store.getters["portalemail/getSubscriberId"]) &&
      (store.getters["portalemail/getSelectedUserId"] > 0)
    ) {
      return false;
    }

    store.commit("portalemail/addItemsToUnreadMails", {isIncreaseCount: false, mailId: newMail.mailBoxId});

    // Check if email is present on unread folder
    let inboxEmail = emails.unread.list.find(email => {
      return email.mailBoxId === newMail.mailBoxId;
    });

    // Check if email is present on inbox folder
    let unreadEmail = emails.inbox.list.find(email => {
      return email.mailBoxId === newMail.mailBoxId;
    });

    // Check if email is present on personal folder
    let personalEmail = null;
    if(newMail.folderId && emails.custom[newMail.folderId]) {
      personalEmail = emails.custom[newMail.folderId].list.find(email => {
        return email.mailBoxId === newMail.mailBoxId;
      });
    }
    let favouriteMode = store.getters["portalemail/getFavouriteMode"];

    // Add email to mail box list
    if (!inboxEmail && !unreadEmail && !personalEmail && !favouriteMode) {
      store.commit("portalemail/addNewEmailToEmailList", {email: newMail, boxType: 'unread', folderId: newMail.folderId});
      store.commit("portalemail/increaseBoxCount", {key: 'unread'});
      if (newMail.folderId) {
        if(!emails.custom[newMail.folderId]) {
          store.commit("portalemail/createNewPersonalFolder", newMail.folderId);
        }
        store.commit("portalemail/addNewEmailToEmailList", {email: newMail, boxType: 'custom', folderId: newMail.folderId});
      } else {
        store.commit("portalemail/addNewEmailToEmailList", {email: newMail, boxType: 'inbox', folderId: newMail.folderId});
        store.commit("portalemail/increaseBoxCount", {key: 'inbox'});
      }
    }
  }
}

export const mail = socket => {
  socket.on("mailReceived", currMail => {
    addMail(currMail);
    showNotification(currMail);
  });
};
